/* eslint-disable max-classes-per-file */

import { GuidUtils } from "~app/common/utils/guid-utils";

export class InmatningstestRowVm {
    handelseNr: string;
    leveransnummer: string;
    status: string;
    senastInmatt: string;
    _parameter: string;
    feature: string;
    virkesordernummer: string;
    isModified = false;
    guid: string;
    log: string;
    accessToken: string;

    static createNew(handelseNr: string, virkesordernummer: string, parameter: string, feature: string) {
        const row = new InmatningstestRowVm();
        row.handelseNr = handelseNr;
        row._parameter = parameter;
        row.status = InmatningStatusar.ny;
        row.feature = feature;
        row.guid = GuidUtils.newGuid();
        row.isModified = true;
        row.virkesordernummer = virkesordernummer;
        return row;
    }

    static createFromDto(handelseNr: string,
        virkesordernummer: string,
        guid: string,
        parameter: string,
        status: string,
        senastInmatt: string,
        leveransnummer: string,
        feature: string,
        log: string) {
        const row = new InmatningstestRowVm();
        row.handelseNr = handelseNr;
        row._parameter = parameter;
        row.status = status;
        row.senastInmatt = senastInmatt;
        row.leveransnummer = leveransnummer;
        row.guid = guid;
        row.feature = feature;
        row.virkesordernummer = virkesordernummer;
        row.log = log;
        return row;
    }

    set parameter(param: string) {
        this._parameter = param;
        this.setModified();
    }

    get parameter() {
        return this._parameter;
    }

    enqueue(accessToken: string): void {
        this.status = InmatningStatusar.ko;
        this.accessToken = accessToken;
        this.setModified();
    }

    setModified() {
        this.isModified = true;
    }

    setPristine(): void {
        this.isModified = false;
    }
}

export class InmatningStatusar {
    static readonly ny = "Ny";
    static readonly ko = "Kö";
    static readonly fel = "Fel";
}
